import { createSelector } from 'reselect';
import { selectQueryParam } from '../../selectors/routing';

export default createSelector(
  [selectQueryParam('contentPath')],
  (contentPath) => ({
    contentPath,
  }),
);
